import React from "react";
import { ReactComponent as EmmptyDataImage } from "../../assets/images/svg/emptyDerivatives.svg";

const NoDataFinancialAssets = ({
  className,
  image,
  alternateText,
  message,
}) => {
  return (
    <div className={`no_finanacial_asset ${className}`}>
      {image ? <img src={image} alt={alternateText} /> : <EmmptyDataImage />}
      <p>{message}</p>
    </div>
  );
};

export default NoDataFinancialAssets;
